import React from "react";
import {Link} from 'react-router-dom'
const MicrosoftSignInButton = ({...props}) => {
    return (
        <button
            type="button"
            disabled={props.disabled}
            className="flex items-center justify-center gap-2 bg-white text-gray-800 font-medium py-2 px-4 rounded border border-gray-300 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors min-w-40"
            onClick={(e) => {
                if (props.validateBeforeSubmit && !props.validateBeforeSubmit()) {
                    return e.preventDefault();
                }
                let path = '/oauth/microsoft/login'
                if (props.registration) {
                    path += '?register=1';
                }
                window.location.href = window.location.origin + path
            }}
        >
            <svg
                width="20"
                height="20"
                viewBox="0 0 21 21"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect x="1" y="1" width="9" height="9" fill="#f25022" />
                <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
                <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
                <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
            </svg>
            <span>{props.loginText ? `${props.loginText} ` : ''}Microsoft</span>
        </button>
    );
};
const SSOSignInButton = ({...props}) => {
    return (
        <a
            className="flex items-center justify-center gap-2 bg-secondary text-white font-medium py-2 px-4 rounded border border-secondary-dark shadow-sm hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition-colors min-w-40"
            href={props.customSSO}
            onClick={(e) => {
                if (props.validateBeforeSubmit && !props.validateBeforeSubmit()) {
                    return e.preventDefault();
                }
                // let path = ''
                // if (props.registration) {
                //     path += '?register=1';
                // }
                // window.location.href = props.customSSO;
            }}
        >

            <span>Login via Organization's SSO Provider</span>
        </a>
    );
};

const SSOAuthorizationButtons = (props = {}) => {

    if (props.customSSO) {
        return (<SSOSignInButton {...props}/>)
    }
    return <MicrosoftSignInButton {...props}/>
}

export default SSOAuthorizationButtons;